import { useEffect } from 'react'

const DEFAULT_TITLE = 'One Day Dance — NYC Dance Media Company'

/**
 * Sets the document title and (optionally) the meta description for the
 * current page. Restores the site-wide defaults when the component unmounts.
 * Static OG/Twitter tags in index.html handle social share previews — this
 * hook is for browser tab UX.
 */
export function useDocumentMeta(title: string, description?: string): void {
  useEffect(() => {
    const prevTitle = document.title
    document.title = title ? `${title} — One Day Dance` : DEFAULT_TITLE

    let descEl: HTMLMetaElement | null = null
    let prevDesc: string | null = null
    if (description !== undefined) {
      descEl = document.querySelector('meta[name="description"]')
      if (descEl) {
        prevDesc = descEl.getAttribute('content')
        descEl.setAttribute('content', description)
      }
    }

    return () => {
      document.title = prevTitle
      if (descEl && prevDesc !== null) descEl.setAttribute('content', prevDesc)
    }
  }, [title, description])
}
